{
  "MFA_SETTINGS": {
    "TITLE": "Two-Factor Authentication",
    "SUBTITLE": "Protect your account from unauthorized access with TOTP-based authentication. This adds an extra layer of security to your account.",
    "DESCRIPTION": "Add an extra layer of security to your account using a time-based one-time password (TOTP)",
    "STATUS_TITLE": "סטטוס אימות",
    "STATUS_DESCRIPTION": "Manage your two-factor authentication settings and backup recovery codes",
    "ENABLED": "מופעל",
    "DISABLED": "כבוי",
    "STATUS_ENABLED": "Two-factor authentication is active",
    "STATUS_ENABLED_DESC": "חשבונך מוגן באמצעות שכבת אבטחה נוספת",
    "ENABLE_BUTTON": "Enable Two-Factor Authentication",
    "ENHANCE_SECURITY": "שפר את אבטחת חשבונך",
    "ENHANCE_SECURITY_DESC": "Two-factor authentication adds an extra layer of security by requiring a verification code from your authenticator app in addition to your password.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "סרוק קוד QR באמצעות אפליקציית האימות שלך",
      "STEP1_DESCRIPTION": "Use Google Authenticator, Authy, or any TOTP-compatible app",
      "LOADING_QR": "טוען...",
      "MANUAL_ENTRY": "לא מצליח לסרוק? הזן קוד ידנית",
      "SECRET_KEY": "מפתח סודי",
      "COPY": "עותק",
      "ENTER_CODE": "Enter the 6-digit code from your authenticator app",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "אמת והמשך",
      "CANCEL": "ביטול",
      "ERROR_STARTING": "אימות רב-שלבי (MFA) אינו מופעל. אנא פנה למנהל המערכת.",
      "INVALID_CODE": "קוד אימות לא חוקי",
      "SECRET_COPIED": "המפתח הסודי הועתק ללוח",
      "SUCCESS": "Two-factor authentication has been enabled successfully"
    },
    "BACKUP": {
      "TITLE": "שמור את קודי הגיבוי שלך",
      "DESCRIPTION": "שמור קודים אלה בבטחה. ניתן להשתמש בכל אחד מהם פעם אחת אם תאבד גישה למאמת שלך",
      "IMPORTANT": "חשוב:",
      "IMPORTANT_NOTE": " שמור קודים אלה במיקום מאובטח. לא תוכל לראות אותם שוב.",
      "DOWNLOAD": "הורד",
      "COPY_ALL": "העתק הכל",
      "CONFIRM": "שמרתי את קודי הגיבוי שלי במיקום מאובטח ואני מבין/ה שלא אוכל לראות אותם שוב",
      "COMPLETE_SETUP": "השלם הגדרה",
      "CODES_COPIED": "קודי הגיבוי הועתקו ללוח"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "קודי גיבוי",
      "BACKUP_CODES_DESC": "צור קודים חדשים אם איבדת או השתמשת בקודים הקיימים שלך",
      "REGENERATE": "צור מחדש קודי גיבוי",
      "DISABLE_MFA": "השבת אימות דו-שלבי (2FA)",
      "DISABLE_MFA_DESC": "Remove two-factor authentication from your account",
      "DISABLE_BUTTON": "Disable Two-Factor Authentication"
    },
    "DISABLE": {
      "TITLE": "Disable Two-Factor Authentication",
      "DESCRIPTION": "You'll need to enter your password and a verification code to disable two-factor authentication.",
      "PASSWORD": "סיסמה",
      "OTP_CODE": "קוד אימות",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "קוד גיבוי",
      "BACKUP_CODE_PLACEHOLDER": "הזן אחד מקודי הגיבוי שלך",
      "USE_BACKUP_CODE": "Lost access to your authenticator? Use a backup code instead",
      "USE_OTP_CODE": "Use a verification code from your authenticator app",
      "CONFIRM": "השבת 2FA",
      "CANCEL": "ביטול",
      "SUCCESS": "Two-factor authentication has been disabled",
      "ERROR": "השבתת MFA נכשלה. אנא בדוק את פרטי הכניסה שלך."
    },
    "REGENERATE": {
      "TITLE": "צור מחדש קודי גיבוי",
      "DESCRIPTION": "פעולה זו תבטל את קודי הגיבוי הקיימים שלך ותיצור חדשים. הזן את קוד האימות שלך כדי להמשיך.",
      "OTP_CODE": "קוד אימות",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "צור קודים חדשים",
      "CANCEL": "ביטול",
      "NEW_CODES_TITLE": "קודי גיבוי חדשים נוצרו",
      "NEW_CODES_DESC": "קודי הגיבוי הישנים שלך בוטלו. שמור קודים חדשים אלה במיקום מאובטח.",
      "CODES_IMPORTANT": "חשוב:",
      "CODES_IMPORTANT_NOTE": " ניתן להשתמש בכל קוד פעם אחת בלבד. שמור אותם לפני סגירת חלון זה.",
      "DOWNLOAD_CODES": "הורד קודים",
      "COPY_ALL_CODES": "העתק את כל הקודים",
      "CODES_SAVED": "שמרתי את הקודים שלי",
      "SUCCESS": "קודי גיבוי חדשים נוצרו",
      "ERROR": "יצירת קודי גיבוי מחדש נכשלה"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "Two-Factor Authentication",
    "DESCRIPTION": "הזן את קוד האימות שלך כדי להמשיך",
    "AUTHENTICATOR_APP": "אפליקציית אימות",
    "BACKUP_CODE": "קוד גיבוי",
    "ENTER_OTP_CODE": "Enter 6-digit code from your authenticator app",
    "ENTER_BACKUP_CODE": "הזן אחד מקודי הגיבוי שלך",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "אמת",
    "TRY_ANOTHER_METHOD": "נסה שיטת אימות אחרת",
    "CANCEL_LOGIN": "בטל וחזור לכניסה",
    "HELP_TEXT": "נתקלת בבעיות בכניסה?",
    "LEARN_MORE": "למד עוד על 2FA",
    "HELP_MODAL": {
      "TITLE": "Two-Factor Authentication Help",
      "AUTHENTICATOR_TITLE": "שימוש באפליקציית אימות",
      "AUTHENTICATOR_DESC": "Open your authenticator app (Google Authenticator, Authy, etc.) and enter the 6-digit code shown for your account.",
      "BACKUP_TITLE": "שימוש בקוד גיבוי",
      "BACKUP_DESC": "אם אין לך גישה לאפליקציית האימות שלך, תוכל להשתמש באחד מקודי הגיבוי ששמרת בעת הגדרת 2FA. ניתן להשתמש בכל קוד פעם אחת בלבד.",
      "CONTACT_TITLE": "זקוק לעזרה נוספת?",
      "CONTACT_DESC_CLOUD": "אם איבדת גישה גם לאפליקציית האימות וגם לקודי הגיבוי שלך, אנא פנה לתמיכה של Chatwoot לקבלת סיוע.",
      "CONTACT_DESC_SELF_HOSTED": "אם איבדת גישה גם לאפליקציית האימות וגם לקודי הגיבוי שלך, אנא פנה למנהל המערכת שלך לקבלת סיוע."
    },
    "VERIFICATION_FAILED": "האימות נכשל. אנא נסה שוב."
  }
}
